import { render, staticRenderFns } from "./ASlide.vue?vue&type=template&id=8eef487c&scoped=true&"
import script from "./ASlide.vue?vue&type=script&lang=js&"
export * from "./ASlide.vue?vue&type=script&lang=js&"
import style0 from "./ASlide.vue?vue&type=style&index=0&id=8eef487c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eef487c",
  null
  
)

export default component.exports